import React from 'react';
import { Drawer, List, Typography } from 'antd';
import { EST3_CONTROL_CENTER_NAV } from './epcEstimateControlCenter.nav';
import type { Est3NavGroupKey, Est3NavLeafKey } from './epcEstimateControlCenter.nav';

const { Text } = Typography;

export interface EpcEstimateSectionsDrawerProps {
  open: boolean;
  onClose: () => void;
  onSelectLeaf: (leaf: Est3NavLeafKey, group: Est3NavGroupKey) => void;
  availableLeaves?: Set<Est3NavLeafKey>;
}

export const EpcEstimateSectionsDrawer: React.FC<EpcEstimateSectionsDrawerProps> = ({
  open,
  onClose,
  onSelectLeaf,
  availableLeaves,
}) => (
  <Drawer title="Estimate sections" open={open} onClose={onClose} width={320}>
    <List
      size="small"
      dataSource={EST3_CONTROL_CENTER_NAV}
      renderItem={(group) => (
        <List.Item style={{ display: 'block', padding: '8px 0' }}>
          <Text strong style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: 0.5 }}>
            {group.label}
          </Text>
          <List
            size="small"
            dataSource={group.leaves.filter(
              (l) => !availableLeaves || availableLeaves.has(l.key)
            )}
            renderItem={(leaf) => (
              <List.Item style={{ padding: '4px 0', border: 'none' }}>
                <a
                  onClick={() => {
                    onSelectLeaf(leaf.key, group.key);
                    onClose();
                  }}
                >
                  {leaf.label}
                </a>
              </List.Item>
            )}
          />
        </List.Item>
      )}
    />
  </Drawer>
);
